export default "__VITE_ASSET__BLXKb0W2__"